"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _excluded = ["className", "children"],
  _excluded2 = ["headingCopy", "children"];
var _templateObject;
var SingleColumn = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    className: className
  }, props), children);
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  margin-bottom: 20px;\n  text-align: center;\n"])));
var SingleColumnBody = function SingleColumnBody(_ref2) {
  var headingCopy = _ref2.headingCopy,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return _react.default.createElement(_PageGrid.default, props, _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    justifyContent: 'center'
  }, props), _react.default.createElement(SingleColumn, null, _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true
  }, " ", headingCopy, " "), props.subheadingCopy ? _react.default.createElement(_Heading.default, {
    hsub: true
  }, " ", props.subheadingCopy, " ") : _react.default.createElement(_react.default.Fragment, null), props.bodyCopy ? _react.default.createElement(_Paragraph.default, null, " ", props.bodyCopy, " ") : _react.default.createElement(_react.default.Fragment, null)), _react.default.createElement(SingleColumn, null, children)));
};
SingleColumnBody.Column = SingleColumn;
var _default = SingleColumnBody;
exports.default = _default;